import {Component, Input} from '@angular/core';
import {WeeklyScheduleIntervalModel} from '../../../base/weekly-schedule/weekly-schedule-interval.model';

@Component({
  selector: 'app-weekly-schedule',
  templateUrl: './weekly-schedule.component.html',
  styleUrls: ['./weekly-schedule.component.scss']
})
export class WeeklyScheduleComponent {
  @Input() scheduleGroups: WeeklyScheduleIntervalModel[];


}
